import { useEffect, useState, useRef } from 'react';

interface SlideTransitionProps {
  children: React.ReactNode;
  slideKey: string | number;
  direction?: 'forward' | 'backward';
}

export function SlideTransition({ children, slideKey, direction: _direction = 'forward' }: SlideTransitionProps) {
  const [displayedChildren, setDisplayedChildren] = useState(children);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const prevSlideKey = useRef(slideKey);

  useEffect(() => {
    if (slideKey !== prevSlideKey.current) {
      // Start fade out with current content
      setIsTransitioning(true);

      // After fade out completes, swap content and fade in
      const timer = setTimeout(() => {
        setDisplayedChildren(children);
        setIsTransitioning(false);
      }, 200); // Match the CSS transition duration

      prevSlideKey.current = slideKey;
      return () => clearTimeout(timer);
    } else {
      // Update children if slideKey hasn't changed (initial render)
      setDisplayedChildren(children);
    }
  }, [slideKey, children]);

  return (
    <div
      className={`
        min-h-[600px]
        transition-all duration-200 ease-out
        ${isTransitioning ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}
      `}
    >
      {displayedChildren}
    </div>
  );
}
